import React from 'react';
import { Flex, Image } from 'antd';
import ErrorImage from '../../../assets/img-404.png';
import { DASHBOARD_PATH } from '@constants/cp-paths';
import { OMS_DASHBOARD_PATH } from '@constants/seller-center-paths';
import { strings } from '@constants/strings';
import { isCP } from '../../../utils/app-utils';
import { Button, Group, Heading } from '../../../common/web-view';

const NotFound = () => {
  return (
    <Group
      template={'1fr 1fr'}
      gap={20}
      style={{
        padding: '6vh 6vw',
        height: 'calc(100vh - var(--ant-layout-header-height))',
        placeContent: 'center',
        background: 'var(--ant-color-bg-base)',
      }}
    >
      <Flex vertical justify="center">
        <Heading style={{ marginTop: 0 }}>Page Not Found!</Heading>
        <p style={{ fontSize: 20, marginTop: 12 }}>We couldn’t find the page that you were looking for.</p>
        <div>
          <Button
            type="primary"
            href={isCP() ? DASHBOARD_PATH : OMS_DASHBOARD_PATH}
            size="large"
            wide
            style={{
              '--ant-button-content-font-size-lg': '20px',
              '--btn-wide-width': '220px',
              height: 48,
            }}
          >
            {strings?.go_to_dashboard}
          </Button>
        </div>
      </Flex>
      <div className="text-end">
        <Image src={ErrorImage} width={550} preview={false} />
      </div>
    </Group>
  );
};

export default NotFound;
